import styled from 'styled-components';

export const Container = styled.div`
  .company-action-body {
    color: ${(props) => props.theme.$dark};
  }

  .company-row {
    cursor: pointer;
  }

  .company-row.unavailable {
    cursor: not-allowed;
    opacity: 0.6;
  }
`;
